(()=>{
 const init=root=>{
  if(root.dataset.changeEditorialReady)return;
  root.dataset.changeEditorialReady='true';
  const colored=!!root.querySelector('[data-ks-weight-product="colored-change-plates-kg"]');
  const swatches={'0.5':'#ffffff','1':'#2e7d32','1.5':'#fbc02d','2':'#1976d2','2.5':'#c62828','5':'#ffffff'};
  root.querySelectorAll('.ks-w-options--pairs .ks-pdp-option strong').forEach(label=>{
   const match=label.textContent.trim().match(/^(\d+(?:\.\d+)?\s*kg)(\s+)(.*)$/i);
   if(!match)return;
   const weight=document.createElement('span');
   weight.className='ce-weight';weight.textContent=match[1];
   const detail=document.createElement('span');
   detail.className='ce-detail';detail.textContent=match[3];
   label.replaceChildren(weight,document.createTextNode(match[2]),detail);
   label.style.setProperty('--ce-swatch',colored?(swatches[parseFloat(match[1])]||'#25282b'):'#25282b');
  });
  root.querySelectorAll('a.ks-assurance-item').forEach(link=>{
   const item=document.createElement('div');item.className=link.className;
   while(link.firstChild)item.append(link.firstChild);
   link.replaceWith(item);
  });
  if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
   const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
     if(!entry.isIntersecting)return;
     entry.target.classList.add('ce-animate');observer.unobserve(entry.target);
    });
   },{threshold:.4});
   root.querySelectorAll('.ce-step-chart').forEach(chart=>observer.observe(chart));
  }
 };
 document.querySelectorAll('.ks-change-page').forEach(init);
 document.addEventListener('shopify:section:load',event=>{
  if(event.target.matches('.ks-change-page'))init(event.target);
 });
})();
